import { HashRouter } from "react-router-dom";
import BasicLayout from "@components/BasicLayout";
import { NavigationGuard, RouteProtector } from "@/RouteProtector";
import { Location } from "react-router-dom";
import { useAppBgStyle } from "@/hooks/App/useAppBgStyle";
import { useInitialSetup } from "@/hooks/App/useInitialSetup";
import classNames from "classnames";
import { bottomSafeHeightAtom } from "./atoms/app";
import { SafeArea } from "antd-mobile";
import { setCssVar } from "./utils/setCssVar";
import { getElementStyle } from "@/utils/getElementStyle.ts";

const App: React.FC = () => {
  const setBottomSafeHeight = useSetAtom(bottomSafeHeightAtom);
  const bottomSafe = document.querySelector(".adm-safe-area.adm-safe-area-position-bottom");
  useEffect(() => {
    if (bottomSafe) {
      const bottomSafePb = getElementStyle({
        elementTarget: ".adm-safe-area.adm-safe-area-position-bottom",
        styleProp: "padding-bottom",
      });
      setBottomSafeHeight(bottomSafePb);
      setCssVar({
        key: "--app-pb-01",
        value: bottomSafePb,
      });
    }
  }, [bottomSafe]);

  try {
    // 初始化设置
    useInitialSetup();
    // 获取应用背景样式
    const appBgStyles = useAppBgStyle();
    // 路由守卫回调
    const [beforeEach, afterEach] = useRouteGuards();

    return (
      <>
        {/* <Teleport to=".app-top-bar" position="prepend">
          <SafeArea position="top" />
        </Teleport> */}

        <div
          className={classNames(["app-background-overlay top-0"])}
          style={{
            ...appBgStyles,
          }}
        ></div>
        <div className={classNames(["w-full"])}>
          <HashRouter
            future={{
              v7_relativeSplatPath: true,
              v7_startTransition: true,
            }}
            basename=""
          >
            <RouteProtector beforeEach={beforeEach} afterEach={afterEach}>
              <BasicLayout />
            </RouteProtector>
          </HashRouter>
        </div>
        {/* {import.meta.env.DEV && <DevTools />} */}
        <Teleport to="body" position="append">
          <SafeArea position="bottom" />
        </Teleport>
      </>
    );
  } catch (error: any) {}
};

// 自定义 hook: 路由守卫
function useRouteGuards(): [NavigationGuard, (to: Location, from: Location | null) => void] {
  const beforeEach: NavigationGuard = useCallback((to, from, next) => {
    console.log(`[路由守卫] 准备从 ${from?.pathname} 跳转到 ${to.pathname}`);
    next();
  }, []);

  const afterEach = useCallback((to: Location, from: Location | null) => {
    console.log(`[路由守卫] 已完成从 ${from?.pathname} 跳转到 ${to.pathname}`);
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, []);

  return [beforeEach, afterEach];
}

export default App;
